import { render, staticRenderFns } from "./CRUDTableBank.vue?vue&type=template&id=3a4201d6"
import script from "./CRUDTableBank.vue?vue&type=script&lang=js"
export * from "./CRUDTableBank.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableBank.vue?vue&type=style&index=0&id=3a4201d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports